import React from "react";
// import ComunServicio from '../../../servicios/Comun';
import ServicioInformacionCrediticia from "../../../servicios/InformacionCreditica";
import moment from "moment";
import { ParametroDetalleArchivoDescargable } from "../../../Contenedores/InformacionCrediticia/ParametroDetalleArchivoDescargable";
import { Notificar, CerrarNotificador } from "../../Comunes/Notificador";
import {
  __DescargarArchivo,
  __DescargarArchivoBlob,
} from "../../../Utils/Funciones";

export class Parametros extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ListaPeriodosArchivosDescargables: [],
      seleccionPeriodo: "",
      mostrarTabla: false,
      nombreArchivoDescargable: "",
      DetalleArchivoDescargable: null,
    };
    this._onSelectPeriodosArchivosDescargables =
      this._onSelectPeriodosArchivosDescargables.bind(this);
    this._onButtonClick = this._onButtonClick.bind(this);
  }

  async componentDidMount() {
    await this.ObtengaCombobox();
  }

  async ObtengaCombobox() {
    let periodosArchivosDescargables =
      await ServicioInformacionCrediticia.ObtengaPeriodoArchivoDescargable();
    this.setState({
      ListaPeriodosArchivosDescargables: periodosArchivosDescargables,
      seleccionPeriodo: periodosArchivosDescargables[0].periodo,
    });
    this.cargarDetalleArchivo();
  }

  async _onSelectPeriodosArchivosDescargables(e) {
    this.setState(
      {
        seleccionPeriodo: e.target.value,
      },
      () => this.cargarDetalleArchivo()
    );
  }

  descargarDocumento = async (documento) => {
    CerrarNotificador();

    const archivo =
      await ServicioInformacionCrediticia.ObtengaArchivoDescargable(documento);

    if(!archivo) return;

    const archivoBlob = new Blob([archivo]);

    if (archivoBlob) {
      __DescargarArchivoBlob(archivoBlob, documento.nombreArchivo);
    } else
      Notificar(
        "error",
        "Ha ocurrido un error intentando obtener el documento"
      );
  };

  descargarFormatoDocumento = async () => {
    CerrarNotificador();
    let resultado =
      await ServicioInformacionCrediticia.ObtengaFormatoArchivoComportamientoDePago();

    if (resultado !== null)
      __DescargarArchivo(resultado.archivoCadena, resultado.nombreArchivo);
    else
      Notificar(
        "error",
        "Ha ocurrido un error intentando obtener el documento"
      );
  };

  cargarDetalleArchivo = async () => {
    let parametro = new ParametroDetalleArchivoDescargable();
    let periodo = this.state.seleccionPeriodo;
    parametro.Periodo = periodo === "" ? null : periodo;
    parametro.CodigoEntidad = periodo;
    let resultado =
      await ServicioInformacionCrediticia.ObtengaDetalleArchivoDescargable(
        parametro
      );
    if (resultado.esValido) {
      this.setState({
        datos: resultado.Personas,
        mostrarTabla: true,
        nombreArchivoDescargable: resultado.nombreArchivo,
        DetalleArchivoDescargable: resultado,
      });
      CerrarNotificador();
    } else {
      this.setState({ mostrarTabla: false });
      Notificar("error", resultado.Errores);
    }
  };

  async _onButtonClick() {
    await this.descargarFormatoDocumento();
  }

  render() {
    return (
      <div id="contenedorArchivosDescargables">
        <div id="ContenedorParametros" className="row">
          <div
            id="contenedorParametrosArchivosDescargables"
            className="col-md-6"
          >
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Datos de búsqueda
                </h6>
              </div>
              <div className="card-body row">
                <div className="col-md-2">
                  <label htmlFor="Periodo">Periodo</label>
                </div>
                <div className="col-md-4">
                  <select
                    id="Periodo"
                    className="form-control"
                    value={this.state.seleccionPeriodo}
                    onChange={(e) =>
                      this._onSelectPeriodosArchivosDescargables(e)
                    }
                  >
                    {this.state.ListaPeriodosArchivosDescargables.map(
                      (item) => (
                        <option key={item.periodo} value={item.periodo}>
                          {item != null
                            ? moment(item.periodo).format("DD/MM/YYYY")
                            : ""}
                        </option>
                      )
                    )}
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div id="contenedorFormatoArchivosDescargables" className="col-md-6">
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Formato de archivo de comportamiento de pago histórico
                </h6>
              </div>
              <div className="card-body">
                <button
                  id="btnDescargarArchivosFormato"
                  type="button"
                  onClick={this._onButtonClick}
                  className="btn btn-primary btn-icon-split"
                >
                  <span className="icon text-white-50">
                    <i className="fas fa-download"></i>
                  </span>
                  <span className="text">Descargar Archivos de Formato</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.mostrarTabla ? (
          <div id="contenedorDetalleArchivoDescargable">
            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Detalle Archivos
                </h6>
              </div>
              <div className="card-body text-gray-800">
                <table
                  id="tbArchivoDescargable"
                  className="table table-responsive-sm table-striped table-sm"
                >
                  <thead className="table-primary">
                    <tr>
                      <th>Archivo</th>
                      <th>Descargar </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="col-sm-2">
                      <td>{this.state.nombreArchivoDescargable}</td>
                      <td className="w-25">
                        <button
                          className="btn btn-primary btn-sm"
                          title="Descargar Archivo"
                          onClick={() =>
                            this.descargarDocumento(
                              this.state.DetalleArchivoDescargable
                            )
                          }
                        >
                          <span className="icon">
                            <i className="fas fa-download"></i>
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
